/* =========================================================
   KOTMO · kotmo-personnalisation.js
   ========================================================= */
(() => {
  const root = document.getElementById('kotmo-perso-root');
  if (!root) return;

  const MAX_UPLOAD_SIZE = 10 * 1024 * 1024; // 10 Mo

  // Capture des parametres publicitaires — meme logique que le script
  // existant du formulaire Globo (theme.liquid, "SUIVI PUBLICITAIRE
  // FORMULAIRE DEVIS") : lus une seule fois depuis l'URL au chargement.
  // Le Meta Pixel de ce site est l'app native Shopify (sandboxee, pas de
  // window.fbq accessible) — l'attribution Meta passe donc par le CAPI
  // cote serveur (Odoo/Make), pas par un appel fbq() client. Ces valeurs
  // sont transmises avec la demande de devis pour permettre ce matching.
  const adParams = (() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const fbclid = params.get('fbclid') || '';
      const gclid = params.get('gclid') || '';
      const src = (params.get('utm_source') || '').toLowerCase();
      const med = (params.get('utm_medium') || '').toLowerCase();

      // Distinction explicite Meta vs Google — memes regles que le script
      // Globo existant, pour que Make/Odoo recoive un champ "source"
      // directement comparable a celui deja utilise pour ce canal.
      // IMPORTANT : Meta et Google sont mutuellement exclusifs ici (comme
      // dans le script d'origine) — ne pas les fusionner dans un seul champ.
      let source = '';
      if ((src === 'facebook' && med === 'cpc') || fbclid) {
        source = 'facebook_ads_form';
      } else if (gclid || (src === 'adwords' && med === 'ppc')) {
        source = 'google_ads_form';
      }

      return {
        fbclid,
        gclid,
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        source,
      };
    } catch (e) {
      return { fbclid: '', gclid: '', utm_source: '', utm_medium: '', source: '' };
    }
  })();

  const isEnglish = () => /\/en(\/|$)/.test(window.location.pathname);

  const STRINGS = {
    fr: {
      personalizationTitle: 'Personnalisation',
      inclusInPrice: 'Inclus dans le prix',
      multBadge: '× emplacements',
      addToCart: (price) => `Ajouter au panier — ${price}`,
      addingToCart: 'Ajout en cours…',
      selectVariant: 'Veuillez sélectionner une variante.',
      variantUnavailable: 'Variante non disponible.',
      atcError: 'Une erreur est survenue. Veuillez réessayer.',
      setupFeeLine: (amount) => `Frais de montage : ${amount}`,
      setupFeeNote: '(ajoutés séparément au panier)',
      addDesign: 'Ajouter un design',
      designLocations: 'Emplacements de design',
      designLocationsNote: '(chaque emplacement ajoute un coût)',
      addPosition: 'Ajouter un placement',
      choosePosition: 'Choisir un placement…',
      removePosition: 'Retirer cet emplacement',
      uploadNote: "Veuillez télécharger un fichier d'une taille maximale de 10 Mo, de préférence aux formats EPS, AI ou PDF. Vectorisation possible sur demande.",
      fileTooLarge: 'Le fichier dépasse la taille maximale de 10 Mo.',
      uploadError: "Erreur lors de l'envoi du fichier. Veuillez réessayer.",
      uploadProcessing: 'traitement en cours…',
      uploadsPending: "Certains fichiers sont encore en cours d'envoi ou ont échoué — veuillez patienter ou réessayer avant de continuer.",
      units: 'unités',
      perPiece: '/pièce',
      minHint: (min) => `Min ${min}`,
      stepHint: (step) => ` · multiple de ${step}`,
      maxHint: (max) => ` · max ${max}`,
      adjustedTo: (qty) => `Ajusté à ${qty} unités`,
      qtyBelowMinimum: (min) => `Quantité minimum non atteinte (${min} requis)`,
      devisButton: 'Votre devis en 1h',
      devisTitle: 'Votre devis en 1h',
      step1: '1. Résumé',
      step2: '2. Vos informations',
      step3: '3. Confirmation',
      next: 'Suivant',
      previous: 'Précédent',
      modify: 'Modifier',
      sendRequest: 'Envoyer ma demande de devis',
      sending: 'Envoi en cours…',
      sent: 'Demande envoyée ✓',
      successMsg: "Votre demande a bien été envoyée. Notre équipe vous contactera dans l'heure.",
      errorMsg: 'Une erreur est survenue. Veuillez nous contacter directement.',
      unitPriceEstimate: 'Prix unitaire estimé :',
      subtotalEstimate: 'Sous-total estimé :',
      setupFeeEstimate: '+ Frais de montage :',
      totalEstimate: 'Total estimé :',
      estimateNote: '* Prix estimatif — votre devis final sera confirmé par notre équipe.',
      quantityLabel: 'Quantité :',
      unitsSuffix: 'unités',
      selectPlaceholder: 'Sélectionner…',
      locationsLabel: 'Emplacements :',
      designsLabel: 'Fichiers de design :',
      reuseNone: 'Design indépendant',
      reuseSameAs: (pos) => `Même design que ${pos}`,
      reuseLabel: 'Reprendre un design utilisé sur un autre emplacement pour économiser en frais de montage',
      groupHint: 'Un seul choix parmi ces options',
      reuseNote: "Un design identique permet d'économiser un frais de montage — le fichier doit être des mêmes dimensions et du même nombre de couleurs.",
      sizesLabel: 'Tailles',
      continueShopping: 'Continuer votre magasinage',
      editItem: 'Modifier',
      removeItem: 'Retirer',
      emptyDevis: 'Votre devis est vide.',
    },
    en: {
      personalizationTitle: 'Personalization',
      inclusInPrice: 'Included in price',
      multBadge: '× locations',
      addToCart: (price) => `Add to cart — ${price}`,
      addingToCart: 'Adding…',
      selectVariant: 'Please select a variant.',
      variantUnavailable: 'Variant not available.',
      atcError: 'An error occurred. Please try again.',
      setupFeeLine: (amount) => `Setup fee: ${amount}`,
      setupFeeNote: '(added separately to cart)',
      addDesign: 'Add a design',
      designLocations: 'Design locations',
      designLocationsNote: '(each location adds a cost)',
      addPosition: 'Add a location',
      choosePosition: 'Choose a location…',
      removePosition: 'Remove this location',
      uploadNote: 'Please upload a file up to 10 MB, preferably in EPS, AI, or PDF format. Vectorization available on request.',
      fileTooLarge: 'The file exceeds the maximum size of 10 MB.',
      uploadError: 'An error occurred while uploading. Please try again.',
      uploadProcessing: 'processing…',
      uploadsPending: 'Some files are still uploading or failed — please wait or retry before continuing.',
      units: 'units',
      perPiece: '/piece',
      minHint: (min) => `Min ${min}`,
      stepHint: (step) => ` · multiples of ${step}`,
      maxHint: (max) => ` · max ${max}`,
      adjustedTo: (qty) => `Adjusted to ${qty} units`,
      qtyBelowMinimum: (min) => `Minimum quantity not reached (${min} required)`,
      devisButton: 'Get a quote in 1h',
      devisTitle: 'Get a quote in 1h',
      step1: '1. Summary',
      step2: '2. Your information',
      step3: '3. Confirmation',
      next: 'Next',
      previous: 'Previous',
      modify: 'Edit',
      sendRequest: 'Send my quote request',
      sending: 'Sending…',
      sent: 'Request sent ✓',
      successMsg: 'Your request has been sent. Our team will contact you within the hour.',
      errorMsg: 'An error occurred. Please contact us directly.',
      unitPriceEstimate: 'Estimated unit price:',
      subtotalEstimate: 'Estimated subtotal:',
      setupFeeEstimate: '+ Setup fee:',
      totalEstimate: 'Estimated total:',
      estimateNote: '* Estimated price — your final quote will be confirmed by our team.',
      quantityLabel: 'Quantity:',
      unitsSuffix: 'units',
      selectPlaceholder: 'Select…',
      locationsLabel: 'Locations:',
      designsLabel: 'Design files:',
      reuseNone: 'Independent design',
      reuseSameAs: (pos) => `Same design as ${pos}`,
      reuseLabel: 'Reuse a design from another location to save on setup fees',
      groupHint: 'Pick only one of these options',
      reuseNote: 'An identical design saves a setup fee — the file must be the same size and same number of colors.',
      sizesLabel: 'Sizes',
      continueShopping: 'Continue shopping',
      editItem: 'Edit',
      removeItem: 'Remove',
      emptyDevis: 'Your quote is empty.',
    },
  };

  const t = (key, ...args) => {
    const dict = STRINGS[isEnglish() ? 'en' : 'fr'];
    const entry = dict[key];
    return typeof entry === 'function' ? entry(...args) : entry;
  };

  const fieldLabel = (f) => (isEnglish() && f.labelEn ? f.labelEn : f.label);
  const optionLabel = (o) => (isEnglish() && o.labelEn ? o.labelEn : o.label);

  let translationsCache = null;
  const fetchTranslations = async () => {
    if (translationsCache) return translationsCache;
    try {
      const res = await fetch('/apps/kotmo?action=translations');
      const data = await res.json();
      translationsCache = { grilles: data.grilles || {}, positions: data.positions || {} };
    } catch (e) {
      console.error('[Kotmo] Erreur chargement traductions:', e);
      translationsCache = { grilles: {}, positions: {} };
    }
    return translationsCache;
  };

  const grilleLabel = (g) => {
    if (!isEnglish() || !translationsCache) return g.nom;
    const tr = translationsCache.grilles[g.odooValue];
    return tr?.labelEn || g.nom;
  };
  const subOptionLabel = (g, soName) => {
    if (!isEnglish() || !translationsCache) return soName;
    const tr = translationsCache.grilles[g.odooValue];
    return tr?.subOptions?.[soName] || soName;
  };
  const positionLabel = (pos) => {
    if (!isEnglish() || !translationsCache) return pos;
    return translationsCache.positions[pos] || pos;
  };

  let grilles = [];
  let positionsByGrille = {};
  let groupesExclusifs = {};
  let precochees = {};
  let verrouillees = {};
  let selectionUnique = false;
  let afficherGrille = true;
  let lignesVolume = [];

  try {
    const raw = root.dataset.grilles || '[]';
    grilles = JSON.parse(raw.replace(/=>/g, ':'));
    // Retro-compatibilite : le champ paliers_de_prix peut desormais etre
    // stocke cote admin comme { useMargin, marginRate, tiers } (calcul par
    // taux de marge, voir app.personnalisations) plutot qu'un simple
    // tableau — on normalise ici, sans avoir a toucher au snippet Liquid
    // qui construit ce JSON en spliçant directement la valeur du champ.
    grilles = grilles.map((g) => {
      if (g.paliers && !Array.isArray(g.paliers) && Array.isArray(g.paliers.tiers)) {
        g.chargerMontageMemeInclus = !!g.paliers.chargerMontageMemeInclus;
        g.paliers = g.paliers.tiers;
      }
      return g;
    });
  } catch (e) { grilles = []; }

  try {
    const raw = root.dataset.positions || '{}';
    positionsByGrille = JSON.parse(raw.replace(/=>/g, ':'));
  } catch (e) { positionsByGrille = {}; }

  // Groupe d'exclusivite par personnalisation (odooValue -> nom de groupe).
  // Deux grilles partageant le meme nom de groupe non vide sont mutuellement
  // exclusives : en activer une desactive automatiquement l'autre.
  try {
    const raw = root.dataset.groupesExclusifs || '{}';
    groupesExclusifs = JSON.parse(raw.replace(/=>/g, ':'));
  } catch (e) { groupesExclusifs = {}; }

  try {
    const raw = root.dataset.precochees || '{}';
    precochees = JSON.parse(raw.replace(/=>/g, ':'));
  } catch (e) { precochees = {}; }

  try {
    const raw = root.dataset.verrouillees || '{}';
    verrouillees = JSON.parse(raw.replace(/=>/g, ':'));
  } catch (e) { verrouillees = {}; }

  const getGroupeExclusif = (g) => groupesExclusifs[g.odooValue] || null;

  // Desactive les autres grilles du meme groupe d'exclusivite qu'une grille
  // qu'on vient d'activer. Fonction centralisee et appelee depuis TOUS les
  // points d'activation (case a cocher ET clic direct sur un bouton
  // d'emplacement) — un oubli sur l'un des deux chemins permettait
  // auparavant d'avoir deux personnalisations "radio" actives en meme temps.
  const applyGroupExclusivity = (activatedId) => {
    const activatedGrille = grilles.find((g) => g.id === activatedId);
    const groupe = activatedGrille ? getGroupeExclusif(activatedGrille) : null;
    if (!groupe) return;
    grilles.forEach((g) => {
      if (g.id !== activatedId && getGroupeExclusif(g) === groupe && !g.verrouille) {
        state.active[g.id] = false;
      }
    });
  };

  selectionUnique = root.dataset.selectionUnique === 'true';
  afficherGrille = root.dataset.afficherGrille !== 'false';

  try { lignesVolume = JSON.parse(root.dataset.lignesVolume || '[]'); } catch (e) { lignesVolume = []; }

  const QTY_MIN = parseInt(root.dataset.qtyMin || '1', 10) || 1;
  const QTY_MAX = parseInt(root.dataset.qtyMax || '0', 10) || 0;
  const QTY_STEP = parseInt(root.dataset.qtyStep || '1', 10) || 1;

  // Messages libres sous les boutons (voir Reglages dans l'app) — memes
  // sur toutes les fiches produit, un seul jeu FR/EN transmis par Liquid,
  // le widget choisit la langue via isEnglish() (meme logique que le
  // reste du widget).
  const storefrontMessage1 = isEnglish() ? (root.dataset.msg1En || '') : (root.dataset.msg1Fr || '');
  const storefrontMessage2 = isEnglish() ? (root.dataset.msg2En || '') : (root.dataset.msg2Fr || '');

  if (!grilles.length) return;

  const getProdTiers = () => {
    // Priorite : palier specifique a la variante selectionnee (si defini
    // via les lignes Achats Odoo cote produit — voir variantPriceOverrides
    // dans app.apercu.$id.jsx). Sinon, repli sur le palier general du
    // produit — comportement historique, inchange pour les produits qui
    // n'ont que des paliers generaux (ex. broderie/serigraphie).
    const variantId = getCurrentVariantId();
    if (variantId) {
      const variantTiers = getVariantTiersMap()[variantId];
      if (Array.isArray(variantTiers) && variantTiers.length) return variantTiers;
    }
    try {
      const el = document.getElementById('kotmo-grille-produit');
      if (el) {
        const parsed = JSON.parse(el.textContent || '[]');
        if (Array.isArray(parsed) && parsed.length) return parsed;
      }
    } catch (e) {}
    try {
      const bracketEl = document.querySelector('[data-knd-bracket]');
      if (bracketEl) return JSON.parse(bracketEl.dataset.tiers || '[]');
    } catch (e) {}
    return [];
  };

  const getVariantTiersMap = () => {
    try {
      const el = document.getElementById('kotmo-grille-variantes');
      if (el) return JSON.parse(el.textContent || '{}') || {};
    } catch (e) {}
    return {};
  };

  const getCurrentVariantId = () => {
    try {
      const variantEl = document.querySelector('[data-selected-variant]');
      if (variantEl) {
        const v = JSON.parse(variantEl.textContent);
        if (v && v.id != null) return String(v.id);
      }
    } catch (e) {}
    // Repli principal : l'ID transmis directement par le snippet Liquid
    // (product.selected_or_first_available_variant.id), fiable meme sur les
    // produits pilotes uniquement par la grille de prix Kotmo, sans aucune
    // variante configuree ni formulaire d'achat natif visible sur la page.
    try {
      const fromWidget = root.dataset.currentVariantId;
      if (fromWidget) return String(fromWidget);
    } catch (e) {}
    // Repli pour les produits simples (une seule variante "Default Title") :
    // le variant-picker (et donc [data-selected-variant]) n'est rendu par le
    // theme que si le produit a plus d'une variante — voir
    // main-product__variant-picker.liquid ({% unless product.has_only_default_variant %}).
    // L'input cache .product-variant-id, lui, est toujours rendu dans le
    // formulaire d'ajout au panier (main-product__buy-buttons.liquid), avec
    // ou sans variantes, et est unique a ce formulaire (aucune collision
    // avec les cartes de produits recommandes, qui utilisent un autre
    // mecanisme).
    try {
      const hiddenIdInput = document.querySelector('input.product-variant-id');
      if (hiddenIdInput && hiddenIdInput.value) {
        return String(hiddenIdInput.value);
      }
    } catch (e) {}
    // Dernier recours : Shopify inscrit l'ID de la variante affichee dans
    // le parametre ?variant= de l'URL lorsque present.
    try {
      const params = new URLSearchParams(window.location.search);
      const fromUrl = params.get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) {}
    return null;
  };

  let currentQty = QTY_MIN;
  // Blocage externe de quantite — mis a jour par tout script tiers qui impose
  // sa propre quantite (ex. kotmo-size-breakdown*.js, grille de tailles) via
  // l'evenement "kotmo:price-update". Quand actif, le bouton ATC du widget se
  // grise, meme si ce widget lui-meme n'a pas de contrainte de minimum.
  let externalQtyBlocked = false;
  let externalQtyMinRequired = null;
  // Répartition par taille fournie par un répartiteur externe (ex.
  // kotmo-size-breakdown-nouveau-systeme.js) via l'événement
  // "kotmo:price-update" — ex. { XS: 12, M: 12, L: 334 }. null tant
  // qu'aucune donnée n'a encore été reçue (répartiteur absent/inactif).
  let externalSizeBreakdown = null;
  const state = { active: {}, expanded: {}, subOption: {}, subOptionByPos: {}, sameAsPos: {}, positions: {}, files: {}, fileUrls: {}, fileProcessing: {}, fileErrors: {} };

  grilles.forEach(g => {
    g.verrouille = !!(verrouillees[g.odooValue] || verrouillees[g.nom]);
    state.active[g.id] = !!(precochees[g.odooValue] || precochees[g.nom]);
    state.expanded[g.id] = false;
    state.positions[g.id] = new Set();
    state.subOptionByPos[g.id] = {};
    state.sameAsPos[g.id] = {};
    if (g.sousOptions && g.sousOptions.length) {
      state.subOption[g.id] = g.sousOptions[0].name;
    }
  });

  const prodTiersInit = getProdTiers();
  if (prodTiersInit && prodTiersInit.length) {
    currentQty = Math.max(QTY_MIN, prodTiersInit[0].quantity || QTY_MIN);
  }

  const fmt = (n) => new Intl.NumberFormat('fr-CA', {
    style: 'currency', currency: 'CAD', minimumFractionDigits: 2
  }).format(n);

  const escapeHtml = (str) => String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  // Formate la répartition par taille externe (ex. { XS: 12, M: 12, L: 334 })
  // en texte lisible "XS: 12, M: 12, L: 334" — ignore les tailles à 0, et
  // renvoie une chaîne vide si aucune donnée n'a été reçue (répartiteur
  // absent/inactif), pour ne rien ajouter dans ce cas au panier ou au devis.
  const formatSizeBreakdown = () => {
    if (!externalSizeBreakdown) return '';
    return Object.entries(externalSizeBreakdown)
      .filter(([, qty]) => Number(qty) > 0)
      .map(([size, qty]) => `${size}: ${qty}`)
      .join(', ');
  };

  const clampQty = (val) => {
    let v = parseInt(val, 10);
    if (isNaN(v) || v < QTY_MIN) v = QTY_MIN;
    if (QTY_MAX > 0 && v > QTY_MAX) v = QTY_MAX;
    const offset = v - QTY_MIN;
    const steps = Math.floor(offset / QTY_STEP);
    const aligned = QTY_MIN + steps * QTY_STEP;
    if (QTY_MAX > 0 && aligned > QTY_MAX) return QTY_MAX - ((QTY_MAX - QTY_MIN) % QTY_STEP);
    return aligned;
  };

  const getPrixPourQty = (paliers, qty) => {
    if (!paliers || !paliers.length) return null;
    let p = null;
    for (const t of paliers) { if (qty >= t.quantity) p = t.unit_price; }
    return p;
  };

  // ── Emplacements possibles pour une grille (liste complète, pas seulement
  // ceux sélectionnés) — sert à déterminer si le choix imbriqué (couleurs,
  // etc.) doit être proposé globalement (1 emplacement ou moins) ou par
  // emplacement (plus d'un emplacement possible).
  const grillePositions = (g) => positionsByGrille[g.odooValue] || positionsByGrille[g.nom] || [];

  const hasPerPositionSubOptions = (g) =>
    !!(g.sousOptions && g.sousOptions.length && grillePositions(g).length > 1);

  // ── Nom de la sous-option (ex: "4 couleurs") active pour un emplacement
  // donné. Si la grille a plus d'un emplacement possible, chaque emplacement
  // a son propre choix (state.subOptionByPos). Sinon, un seul choix global
  // pour toute la grille (comportement historique, state.subOption).
  const getSubOptionName = (g, pos) => {
    if (!g.sousOptions || !g.sousOptions.length) return null;
    if (hasPerPositionSubOptions(g) && pos != null) {
      return (state.subOptionByPos[g.id] && state.subOptionByPos[g.id][pos]) || g.sousOptions[0].name;
    }
    return state.subOption[g.id] || g.sousOptions[0].name;
  };

  // ── Emplacement référencé par "même design que", le cas échéant — null
  // si cet emplacement a un choix indépendant.
  const getReuseTarget = (g, pos) => (state.sameAsPos[g.id] && state.sameAsPos[g.id][pos]) || null;

  // ── Nom de sous-option EFFECTIF pour un emplacement : si l'emplacement
  // réutilise le design d'un autre ("même design que"), on suit le choix
  // de couleurs de l'emplacement référencé (même taille/nombre de couleurs
  // exigé) ; sinon son propre choix (getSubOptionName).
  const getEffectiveSubOptionName = (g, pos) => {
    const refPos = getReuseTarget(g, pos);
    if (refPos) return getSubOptionName(g, refPos);
    return getSubOptionName(g, pos);
  };

  const getSubOptionObj = (g, pos) => {
    if (!g.sousOptions || !g.sousOptions.length) return null;
    const name = getEffectiveSubOptionName(g, pos);
    return g.sousOptions.find(s => s.name === name) || null;
  };

  const getPaliersForPos = (g, pos) => {
    const sub = getSubOptionObj(g, pos);
    if (sub && sub.price_tiers && sub.price_tiers.length) return sub.price_tiers;
    return g.paliers || [];
  };

  // ── Frais de montage pour un emplacement — gratuit (0$) quand cet
  // emplacement réutilise le design d'un autre (déjà préparé, c'est tout
  // l'intérêt de "même design que"). Le coût unitaire, lui, reste basé
  // sur la grille de prix du nombre de couleurs (via getPaliersForPos),
  // car l'impression elle-même a toujours un coût.
  const getFeeForPos = (g, pos) => {
    if (getReuseTarget(g, pos)) return 0;
    const sub = getSubOptionObj(g, pos);
    if (sub) return sub.setup_fee || 0;
    return g.fraisMontage || 0;
  };

  // ── Texte descriptif du choix pour un emplacement (couleur choisie, ou
  // "même design que X") — utilisé dans le récap devis, les propriétés
  // panier, et les propriétés du formulaire.
  const formatPositionDetail = (g, pos) => {
    const refPos = getReuseTarget(g, pos);
    if (refPos) return `${positionLabel(pos)} (${t('reuseSameAs', positionLabel(refPos))})`;
    const subName = getSubOptionName(g, pos);
    return subName ? `${positionLabel(pos)} (${subOptionLabel(g, subName)})` : positionLabel(pos);
  };

  // ── Coût unitaire de personnalisation pour une grille, à une quantité
  // donnée. Quand la grille multiplie par emplacement ET qu'au moins un
  // emplacement est sélectionné, on additionne le prix propre à CHAQUE
  // emplacement (qui peut différer si le choix imbriqué — ex: nombre de
  // couleurs — varie d'un emplacement à l'autre). Sinon, comportement
  // historique : un seul prix multiplié par le nombre d'emplacements.
  const computeGrilleUnitCost = (g, qty) => {
    if (g.prixInclus || g.prixDejaInclus) return 0;
    const positions = [...state.positions[g.id]];
    if (g.multiplierParEmplacement && positions.length > 0) {
      return positions.reduce((sum, pos) => {
        const paliers = getPaliersForPos(g, pos);
        return sum + (getPrixPourQty(paliers, qty) || 0);
      }, 0);
    }
    const paliers = getPaliersForPos(g, null);
    const basePrice = getPrixPourQty(paliers, qty) || 0;
    const posCount = positions.length || 1;
    return g.multiplierParEmplacement ? basePrice * posCount : basePrice;
  };

  // ── Frais de montage pour une grille — même logique que ci-dessus :
  // additionné par emplacement quand la grille multiplie par emplacement.
  const computeGrilleSetupFee = (g) => {
    const positions = [...state.positions[g.id]];
    if (g.multiplierParEmplacement && positions.length > 0) {
      return positions.reduce((sum, pos) => sum + getFeeForPos(g, pos), 0);
    }
    const fee = getFeeForPos(g, null);
    const posCount = positions.length || 1;
    return g.multiplierParEmplacement ? fee * posCount : fee;
  };

  const computePersoTotal = () => {
    let unitCost = 0, setupFee = 0;
    grilles.forEach(g => {
      if (!state.active[g.id]) return;
      const priceIncluded = g.prixInclus || g.prixDejaInclus;
      if (!priceIncluded) {
        unitCost += computeGrilleUnitCost(g, currentQty);
      }
      if (!priceIncluded || g.chargerMontageMemeInclus) {
        setupFee += computeGrilleSetupFee(g);
      }
    });
    return { unitCost, setupFee };
  };

  const computeTotalUnitPrice = () => {
    const prodTiers = getProdTiers();
    const getProdUnit = (qty) => {
      let t = null;
      for (const x of prodTiers) { if (qty >= x.quantity) t = x; }
      return t ? t.unit_price : null;
    };
    const { unitCost } = computePersoTotal();
    return (getProdUnit(currentQty) || 0) + unitCost;
  };

  const renderSetupFeeLine = () => {
    const el = document.getElementById('kotmo-setup-fee-line');
    if (!el) return;
    const { setupFee } = computePersoTotal();
    if (setupFee > 0) {
      el.innerHTML = `<div class="kotmo-perso__setup-fee">${t('setupFeeLine', `<strong>${fmt(setupFee)}</strong>`)} <span>${t('setupFeeNote')}</span></div>`;
    } else {
      el.innerHTML = '';
    }
  };

  const dispatchChange = () => {
    const { unitCost, setupFee } = computePersoTotal();
    document.dispatchEvent(new CustomEvent('kotmo:personalization-change', {
      detail: { unitCost, setupFee },
    }));
    injectPropsIntoForms();
    renderVolumeTable();
    renderSetupFeeLine();
    updateAtcButton();
  };

  const updateAtcButton = () => {
    const btn = document.getElementById('kotmo-btn-atc');
    if (!btn) return;
    const totalUnit = computeTotalUnitPrice();
    const totalLine = totalUnit * currentQty;
    btn.textContent = t('addToCart', fmt(totalLine));
  };

  const setQty = (qty) => {
    // Choisir un palier de volume (ou saisir une quantité libre) directement
    // dans le widget entre en contradiction avec une répartition par taille
    // encore active (le total des tailles ne correspondrait plus au palier
    // choisi) — on décoche donc automatiquement la case du répartiteur et on
    // ferme son panneau, en réutilisant son propre mécanisme de décochage
    // (déclenche son "change", qui gère lecture-seule/hint/props proprement)
    // plutôt que de dupliquer cette logique ici.
    const sizeBreakdownToggle = document.querySelector('.ksb-toggle');
    if (sizeBreakdownToggle && sizeBreakdownToggle.checked) {
      sizeBreakdownToggle.checked = false;
      sizeBreakdownToggle.dispatchEvent(new Event('change', { bubbles: true }));
    }

    currentQty = clampQty(qty);
    // Toute interaction directe avec la quantite du widget (clic sur un
    // palier de volume, saisie libre) signifie que ce controle est
    // redevenu la source de verite pour la quantite — on leve donc tout
    // blocage externe residuel (ex. laisse par le repartiteur de tailles
    // avant un decochage), sinon le bouton ATC et le message d'erreur
    // restent "figes" indefiniment malgre une nouvelle quantite valide.
    externalQtyBlocked = false;
    document.querySelectorAll('input[name="quantity"]').forEach(i => {
      i.value = currentQty;
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
    dispatchChange();
    render();
  };

  // Vrai si un fichier a été sélectionné pour un emplacement actif mais
  // que son URL n'est pas encore disponible (en cours d'envoi, en
  // traitement Shopify, ou en échec) — utilisé pour bloquer ATC/devis
  // tant que ce n'est pas résolu, afin que le lien ne soit jamais perdu.
  const hasPendingUploads = () => {
    for (const g of grilles) {
      if (!state.active[g.id]) continue;
      for (const pos of state.positions[g.id]) {
        const key = `${g.id}::${pos}`;
        if (state.files[key] && !state.fileUrls[key]) return true;
      }
    }
    return false;
  };

  /* ── Upload fichier vers la sync app ── */
  const uploadFile = async (grilleId, position, file) => {
    const key = `${grilleId}::${position}`;
    delete state.fileErrors[key];

    const formData = new FormData();
    formData.append('file', file);
    formData.append('product_id', root.dataset.productId || '');
    formData.append('position', position);
    formData.append('grille', grilleId);

    try {
      const res = await fetch(root.dataset.uploadUrl || '/apps/kotmo-upload', {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || t('uploadError'));
      }

      if (data.url) {
        state.fileUrls[key] = data.url;
        state.fileProcessing[key] = false;
      } else if (data.processing) {
        state.fileProcessing[key] = true;
      }
    } catch (e) {
      console.error('[Kotmo] Upload error:', e);
      state.fileErrors[key] = e.message || t('uploadError');
    } finally {
      render();
    }
  };

  /* ── ATC Handler ── */
  const handleAtc = async () => {
    if (externalQtyBlocked) {
      alert(t('qtyBelowMinimum', externalQtyMinRequired));
      return;
    }
    if (hasPendingUploads()) {
      alert(t('uploadsPending'));
      return;
    }

    const variantId = getCurrentVariantId();
    if (!variantId) { alert(t('selectVariant')); return; }

    const { unitCost, setupFee } = computePersoTotal();
    const totalUnitPrice = computeTotalUnitPrice();
    const lineTotal = totalUnitPrice * currentQty;

    const properties = {
      '_kotmo_prix_unitaire': totalUnitPrice.toFixed(2),
      '_kotmo_prix_total': lineTotal.toFixed(2),
      '_kotmo_frais_montage': setupFee.toFixed(2),
      '_kotmo_qty': String(currentQty),
    };

    // Répartition par taille (ex. "XS: 12, M: 12, L: 334") — fournie par un
    // répartiteur externe (voir externalSizeBreakdown plus haut). Absente si
    // ce produit n'utilise pas de répartition par taille.
    const sizeBreakdownStr = formatSizeBreakdown();
    if (sizeBreakdownStr) {
      properties[t('sizesLabel')] = sizeBreakdownStr;
    }

    grilles.forEach(g => {
      if (!state.active[g.id]) return;
      const gLabel = grilleLabel(g);
      const positions = [...state.positions[g.id]];
      const perPosition = hasPerPositionSubOptions(g);

      if (!perPosition && state.subOption[g.id]) {
        properties[`Personnalisation - ${gLabel} - Option`] = subOptionLabel(g, state.subOption[g.id]);
      }

      if (positions.length) {
        if (perPosition) {
          // Choix imbriqué par emplacement — inclut le choix (ex: "4 couleurs"
          // ou "même design que Devant") à côté du nom de l'emplacement.
          properties[`Personnalisation - ${gLabel} - Emplacements`] = positions.map(pos => formatPositionDetail(g, pos)).join(', ');
        } else {
          properties[`Personnalisation - ${gLabel} - Emplacements`] = positions.map(positionLabel).join(', ');
        }
      }
      positions.forEach(pos => {
        const key = `${g.id}::${pos}`;
        const url = state.fileUrls[key];
        if (url) {
           properties[`_Design - ${gLabel} - ${positionLabel(pos)}`] = url;
        }
      });
    });

    if (setupFee > 0) {
      properties['Frais de montage'] = fmt(setupFee);
    }

    const btn = document.getElementById('kotmo-btn-atc');
    try {
      if (btn) { btn.disabled = true; btn.textContent = t('addingToCart'); }

      const sectionsParam = 'cart-drawer,cart-counter';
      const res = await fetch(`/cart/add.js?sections=${sectionsParam}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: currentQty, properties }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Erreur ATC');
      }

      const data = await res.json();

      if (data.sections) {
        const cartDrawerBody = document.querySelector('#CartDrawer-Body');
        if (cartDrawerBody && data.sections['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
          const newBody = doc.querySelector('#CartDrawer-Body');
          if (newBody) cartDrawerBody.innerHTML = newBody.innerHTML;
        }

        const cartCounter = document.querySelector('#cart-counter');
        if (cartCounter && data.sections['cart-counter']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data.sections['cart-counter'], 'text/html');
          const newCounter = doc.querySelector('#shopify-section-cart-counter');
          if (newCounter) cartCounter.innerHTML = newCounter.innerHTML;
        }
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      document.dispatchEvent(new CustomEvent('kotmo:cart-updated'));

    } catch (err) {
      console.error('[Kotmo] ATC error:', err);
      alert(err.message || t('atcError'));
    } finally {
      if (btn) {
        btn.disabled = false;
        updateAtcButton();
      }
    }
  };

  /* ── Modal devis (3 étapes : résumé → champs client → confirmation) ── */
  let devisFieldsConfig = null;
  let devisStep = 1;
  let devisValues = {};

  const fetchDevisFields = async () => {
    if (devisFieldsConfig) return devisFieldsConfig;
    try {
      const res = await fetch('/apps/kotmo?action=devis-fields');
      const data = await res.json();
      devisFieldsConfig = Array.isArray(data.fields) ? data.fields : [];
    } catch (e) {
      console.error('[Kotmo] Erreur chargement champs devis:', e);
      devisFieldsConfig = [
        { id: 'nom', label: 'Nom', labelEn: 'Name', name: 'nom', type: 'text', required: true, options: [] },
        { id: 'email', label: 'Courriel', labelEn: 'Email', name: 'email', type: 'email', required: true, options: [] },
      ];
    }
    return devisFieldsConfig;
  };

  const getDevisSummaryData = () => {
    const { setupFee } = computePersoTotal();
    const totalUnitPrice = computeTotalUnitPrice();
    const lineTotal = totalUnitPrice * currentQty;

    let persoSummary = '';
    const designs = [];

    grilles.forEach(g => {
      if (!state.active[g.id]) return;
      const perPosition = hasPerPositionSubOptions(g);
      let line = `<li><strong>${escapeHtml(grilleLabel(g))}</strong>`;

      if (!perPosition && state.subOption[g.id]) {
        line += ` — ${escapeHtml(subOptionLabel(g, state.subOption[g.id]))}`;
      }

      const positions = [...state.positions[g.id]];
      if (positions.length) {
        if (perPosition) {
          const positionDetails = positions.map(pos => formatPositionDetail(g, pos)).join(', ');
          line += ` — ${t('locationsLabel')} ${escapeHtml(positionDetails)}`;
        } else {
          line += ` — ${t('locationsLabel')} ${escapeHtml(positions.map(positionLabel).join(', '))}`;
        }
      }
      line += '</li>';
      persoSummary += line;

      // Collecte des designs uploadés pour cette grille — inclus dans la
      // demande de devis (auparavant perdus, jamais transmis).
      positions.forEach(pos => {
        const key = `${g.id}::${pos}`;
        const url = state.fileUrls[key];
        if (url) {
          designs.push({ grille: grilleLabel(g), position: positionLabel(pos), url });
        }
      });
    });

    const variantEl = document.querySelector('[data-selected-variant]');
    let variantTitle = '';
    try {
      const v = JSON.parse(variantEl?.textContent || '{}');
      variantTitle = v.title && v.title !== 'Default Title' ? ` — ${escapeHtml(v.title)}` : '';
    } catch (e) {}

    const productTitle = escapeHtml(
      document.querySelector('.product__title, h1.product__title')?.textContent?.trim() || ''
    );

    return { setupFee, totalUnitPrice, lineTotal, persoSummary, productTitle, variantTitle, designs };
  };

  /* ── Devis multi-produits — persistance localStorage ──
     Le devis peut désormais contenir plusieurs produits accumulés au fil
     de la navigation ("Continuer votre magasinage"). Une ligne = une page
     produit (clé = URL de la page, sans querystring) : rouvrir le devis
     depuis la même fiche met à jour la ligne existante (nouvelle variante,
     nouvelle quantité, etc.) plutôt que d'en créer une seconde. */
  const DEVIS_STORAGE_KEY = 'kotmo_devis_items';

  const loadDevisItems = () => {
    try {
      const arr = JSON.parse(localStorage.getItem(DEVIS_STORAGE_KEY) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  };

  const saveDevisItems = (items) => {
    try { localStorage.setItem(DEVIS_STORAGE_KEY, JSON.stringify(items)); }
    catch (e) { console.error('[Kotmo] Erreur sauvegarde devis:', e); }
  };

  // Image de la variante sélectionnée — reprend le même script JSON natif
  // que celui déjà lu par getDevisSummaryData() pour le titre de variante.
  // Repli sur l'image principale du produit (data-product-image, injectée
  // par le Liquid) si la variante choisie n'a pas d'image dédiée.
  const getCurrentVariantImage = () => {
    try {
      const variantEl = document.querySelector('[data-selected-variant]');
      const v = JSON.parse(variantEl?.textContent || '{}');
      if (v.featured_image && v.featured_image.src) return v.featured_image.src;
    } catch (e) {}
    return root.dataset.productImage || '';
  };

  const buildCurrentDevisItem = () => {
    const data = getDevisSummaryData();
    const productUrl = window.location.origin + window.location.pathname;
    return {
      id: productUrl,
      productUrl,
      image: getCurrentVariantImage(),
      qty: currentQty,
      tailles: formatSizeBreakdown(),
      ...data,
    };
  };

  const upsertCurrentItemIntoDevis = () => {
    const items = loadDevisItems();
    const newItem = buildCurrentDevisItem();
    const idx = items.findIndex((it) => it.id === newItem.id);
    if (idx >= 0) items[idx] = newItem;
    else items.push(newItem);
    saveDevisItems(items);
    return items;
  };

  const removeDevisItem = (id) => {
    const items = loadDevisItems().filter((it) => it.id !== id);
    saveDevisItems(items);
    return items;
  };

  const getDevisItemsTotals = (items) => items.reduce((acc, it) => {
    acc.lineTotal += Number(it.lineTotal || 0);
    acc.setupFee += Number(it.setupFee || 0);
    return acc;
  }, { lineTotal: 0, setupFee: 0 });

  const renderStepIndicator = (step) => `
    <div class="kotmo-modal__steps">
      <span class="kotmo-modal__step${step === 1 ? ' kotmo-modal__step--active' : ''}">${t('step1')}</span>
      <span class="kotmo-modal__step${step === 2 ? ' kotmo-modal__step--active' : ''}">${t('step2')}</span>
      <span class="kotmo-modal__step${step === 3 ? ' kotmo-modal__step--active' : ''}">${t('step3')}</span>
    </div>
  `;

  const renderDevisItemRow = (it) => {
    const designsLine = (it.designs || []).length
      ? `<p class="kotmo-modal__prix">${t('designsLabel')} <strong>${it.designs.length}</strong></p>`
      : '';
    return `
      <div class="kotmo-modal__item" data-item-id="${escapeHtml(it.id)}">
        <div class="kotmo-modal__item-thumb">
          ${it.image ? `<img src="${escapeHtml(it.image)}" alt="" loading="lazy">` : ''}
        </div>
        <div class="kotmo-modal__item-body">
          <p class="kotmo-modal__item-title">${it.productTitle}${it.variantTitle}</p>
          <p>${t('quantityLabel')} <strong>${it.qty} ${t('unitsSuffix')}</strong></p>
          ${it.persoSummary ? `<ul class="kotmo-modal__perso-list">${it.persoSummary}</ul>` : ''}
          ${designsLine}
          <p class="kotmo-modal__prix">${t('subtotalEstimate')} <strong>${fmt(it.lineTotal)}</strong></p>
          ${it.setupFee > 0 ? `<p class="kotmo-modal__fee">${t('setupFeeEstimate')} <strong>${fmt(it.setupFee)}</strong></p>` : ''}
        </div>
        <div class="kotmo-modal__item-actions">
          <a class="kotmo-modal__item-edit" href="${escapeHtml(it.productUrl)}" title="${t('editItem')}" aria-label="${t('editItem')}">✎</a>
          <button type="button" class="kotmo-modal__item-remove" data-remove-item="${escapeHtml(it.id)}" title="${t('removeItem')}" aria-label="${t('removeItem')}">🗑</button>
        </div>
      </div>
    `;
  };

  const renderDevisStep1 = () => {
    const items = loadDevisItems();
    const { lineTotal, setupFee } = getDevisItemsTotals(items);

    if (items.length === 0) {
      return `
        <p class="kotmo-modal__note">${t('emptyDevis')}</p>
        <div class="kotmo-modal__actions">
          <button type="button" class="kotmo-perso__btn-devis" id="kotmo-devis-continue-shopping" style="width:100%">${t('continueShopping')}</button>
        </div>
      `;
    }

    return `
      <div class="kotmo-modal__items">
        ${items.map(renderDevisItemRow).join('')}
      </div>
      <div class="kotmo-modal__summary">
        <p class="kotmo-modal__prix" style="border-top:1px solid rgba(0,0,0,0.1);padding-top:8px;margin-top:8px;font-size:1.05em;">${t('totalEstimate')} <strong>${fmt(lineTotal + setupFee)}</strong></p>
        <p class="kotmo-modal__note">${t('estimateNote')}</p>
      </div>
      <div class="kotmo-modal__actions kotmo-modal__actions--split">
        <button type="button" class="kotmo-perso__btn-devis" id="kotmo-devis-continue-shopping">${t('continueShopping')}</button>
        <button type="button" class="kotmo-perso__btn-atc" id="kotmo-devis-next-1">${t('next')}</button>
      </div>
    `;
  };

  const renderDevisStep2 = () => {
    let fieldsHtml = '';
    (devisFieldsConfig || []).forEach(f => {
      const rawVal = devisValues[f.name] || '';
      const val = escapeHtml(rawVal);
      const req = f.required ? 'required' : '';
      const reqMark = f.required ? ' *' : '';
      const safeId = `kotmo-devis-${escapeHtml(f.id)}`;
      const safeLabel = escapeHtml(fieldLabel(f));
      const safeName = escapeHtml(f.name);

      if (f.type === 'textarea') {
        fieldsHtml += `<div class="kotmo-modal__field">
          <label for="${safeId}">${safeLabel}${reqMark}</label>
          <textarea id="${safeId}" name="${safeName}" rows="3" ${req}>${val}</textarea>
        </div>`;
      } else if (f.type === 'select') {
        const opts = (f.options || []).filter(o => o.label).map(o => {
          const displayText = escapeHtml(optionLabel(o));
          const submittedValue = escapeHtml(o.label);
          return `<option value="${submittedValue}"${o.label === rawVal ? ' selected' : ''}>${displayText}</option>`;
        }).join('');
        fieldsHtml += `<div class="kotmo-modal__field">
          <label for="${safeId}">${safeLabel}${reqMark}</label>
          <select id="${safeId}" name="${safeName}" ${req}>
            <option value="">${t('selectPlaceholder')}</option>
            ${opts}
          </select>
        </div>`;
      } else {
        fieldsHtml += `<div class="kotmo-modal__field">
          <label for="${safeId}">${safeLabel}${reqMark}</label>
          <input type="${f.type}" id="${safeId}" name="${safeName}" value="${val}" ${req}>
        </div>`;
      }
    });

    return `
      <form id="kotmo-devis-form-step2" class="kotmo-modal__form" novalidate>
        ${fieldsHtml}
        <div id="kotmo-devis-msg" class="kotmo-modal__feedback" aria-live="polite"></div>
        <div class="kotmo-modal__actions kotmo-modal__actions--split">
          <button type="button" class="kotmo-perso__btn-devis" id="kotmo-devis-prev-2">${t('previous')}</button>
          <button type="submit" class="kotmo-perso__btn-atc" id="kotmo-devis-next-2">${t('next')}</button>
        </div>
      </form>
    `;
  };

   const displayValueFor = (f) => {
    const raw = devisValues[f.name] || '';
    if (f.type === 'select') {
      const opt = (f.options || []).find((o) => o.label === raw);
      if (opt) return optionLabel(opt);
    }
    return raw;
  };

  const renderDevisStep3 = () => {
    const items = loadDevisItems();
    const { lineTotal, setupFee } = getDevisItemsTotals(items);
    const itemsLines = items
      .map((it) => `<p>${it.productTitle}${it.variantTitle} — ${it.qty} ${t('unitsSuffix')} — <strong>${fmt(it.lineTotal + (it.setupFee || 0))}</strong></p>`)
      .join('');
    const recap = (devisFieldsConfig || [])
      .filter(f => devisValues[f.name])
      .map(f => `<p><strong>${escapeHtml(fieldLabel(f))} :</strong> ${escapeHtml(displayValueFor(f))}</p>`)
      .join('');

    return `
      <div class="kotmo-modal__summary">
        ${itemsLines}
        <p class="kotmo-modal__prix" style="border-top:1px solid rgba(0,0,0,0.1);padding-top:8px;margin-top:8px;font-size:1.05em;">${t('totalEstimate')} <strong>${fmt(lineTotal + setupFee)}</strong></p>
      </div>
      <div class="kotmo-modal__recap">
        ${recap}
      </div>
      <div id="kotmo-devis-msg" class="kotmo-modal__feedback" aria-live="polite"></div>
      <div class="kotmo-modal__actions kotmo-modal__actions--split">
        <button type="button" class="kotmo-perso__btn-devis" id="kotmo-devis-prev-3">${t('modify')}</button>
        <button type="button" class="kotmo-perso__btn-atc" id="kotmo-devis-submit-final">${t('sendRequest')}</button>
      </div>
    `;
  };

  const renderDevisModal = () => {
    const modal = document.getElementById('kotmo-devis-modal');
    if (!modal) return;

    let stepHtml = '';
    if (devisStep === 1) stepHtml = renderDevisStep1();
    else if (devisStep === 2) stepHtml = renderDevisStep2();
    else stepHtml = renderDevisStep3();

    modal.innerHTML = `
      <div class="kotmo-modal__overlay" id="kotmo-modal-overlay">
        <div class="kotmo-modal__box" role="dialog" aria-modal="true" aria-label="${t('devisTitle')}">
          <button class="kotmo-modal__close" id="kotmo-modal-close" aria-label="Fermer">✕</button>
          <h2 class="kotmo-modal__title">${t('devisTitle')}</h2>
          ${renderStepIndicator(devisStep)}
          ${stepHtml}
        </div>
      </div>
    `;

    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';

    document.getElementById('kotmo-modal-close')?.addEventListener('click', closeDevisModal);
    document.getElementById('kotmo-modal-overlay')?.addEventListener('click', (e) => {
      if (e.target.id === 'kotmo-modal-overlay') closeDevisModal();
    });

    if (devisStep === 1) {
      document.getElementById('kotmo-devis-next-1')?.addEventListener('click', () => {
        devisStep = 2;
        renderDevisModal();
      });
      document.getElementById('kotmo-devis-continue-shopping')?.addEventListener('click', closeDevisModal);
      document.querySelectorAll('[data-remove-item]').forEach((btn) => {
        btn.addEventListener('click', () => {
          removeDevisItem(btn.dataset.removeItem);
          renderDevisModal();
        });
      });
    } else if (devisStep === 2) {
      document.getElementById('kotmo-devis-prev-2')?.addEventListener('click', () => {
        devisStep = 1;
        renderDevisModal();
      });
      document.getElementById('kotmo-devis-form-step2')?.addEventListener('submit', (e) => {
        e.preventDefault();
        const form = e.target;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        const entries = Object.fromEntries(new FormData(form).entries());
        devisValues = { ...devisValues, ...entries };
        devisStep = 3;
        renderDevisModal();
      });
    } else {
      document.getElementById('kotmo-devis-prev-3')?.addEventListener('click', () => {
        devisStep = 2;
        renderDevisModal();
      });
      document.getElementById('kotmo-devis-submit-final')?.addEventListener('click', handleDevisSubmitFinal);
    }
  };

  // ── Tracking Google (via GTM, deja charge sur le site — GTM-5LBSFBD) et
  // Meta Pixel (fbq, deja charge sur le site pour l'ancien formulaire Globo).
  // Deux moments trackes : ouverture du modal (signal d'interet) et
  // soumission reussie (conversion "generate_lead"), avec le montant reel
  // estime du devis. Google/GTM uniquement ici — le pixel Meta de ce site
  // est l'app native Shopify (sandboxee), sans window.fbq accessible.
  // L'attribution Meta pour le devis passe par fbclid transmis au backend
  // (voir handleDevisSubmitFinal) pour matching CAPI cote serveur.
  const trackDevisEvent = (stage) => {
    let value;
    let productTitle;
    try {
      const items = loadDevisItems();
      const { setupFee, lineTotal } = getDevisItemsTotals(items);
      value = Number((lineTotal + setupFee).toFixed(2));
      if (!value) value = undefined;
      productTitle = items.map((it) => it.productTitle).join(', ') || undefined;
    } catch (e) { value = undefined; }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: stage === 'submit' ? 'generate_lead' : 'devis_start',
        devis_stage: stage,
        value,
        currency: 'CAD',
        product_title: productTitle,
      });
    } catch (e) {}
  };

  const openDevisModal = async () => {
    devisStep = 1;
    devisValues = {};
    await Promise.all([fetchDevisFields(), fetchTranslations()]);
    upsertCurrentItemIntoDevis();
    renderDevisModal();
    trackDevisEvent('start');
  };

  const closeDevisModal = () => {
    const modal = document.getElementById('kotmo-devis-modal');
    if (modal) { modal.innerHTML = ''; modal.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  };

  const handleDevisSubmitFinal = async () => {
    if (hasPendingUploads()) {
      const msgEl = document.getElementById('kotmo-devis-msg');
      if (msgEl) {
        msgEl.className = 'kotmo-modal__feedback kotmo-modal__feedback--error';
        msgEl.textContent = t('uploadsPending');
      }
      return;
    }

    const btn = document.getElementById('kotmo-devis-submit-final');
    const msgEl = document.getElementById('kotmo-devis-msg');
    if (btn) { btn.disabled = true; btn.textContent = t('sending'); }

    const items = loadDevisItems();
    const { setupFee, lineTotal } = getDevisItemsTotals(items);

    // Résumé texte multi-produits (une ligne par produit) — conçu pour
    // rester compatible avec le scénario Make.com existant, qui attend un
    // champ "produit" en texte libre. Le détail structuré est transmis en
    // plus via "items" (JSON) pour un usage plus fin ultérieur, sans avoir
    // à casser le mapping Make/Odoo actuel dès maintenant.
    const produitResume = items
      .map((it) => `${it.productTitle}${it.variantTitle} — ${it.qty} ${t('unitsSuffix')} — ${fmt(it.lineTotal + (it.setupFee || 0))}`)
      .join('\n');

    const personnalisationsResume = items
      .map((it) => {
        const clean = (it.persoSummary || '')
          .replace(/<\/li>/g, '\n')
          .replace(/<[^>]*>/g, '')
          .replace(/\n+/g, '\n')
          .trim();
        return clean ? `${it.productTitle} :\n${clean}` : '';
      })
      .filter(Boolean)
      .join('\n\n');

    const allDesigns = items.flatMap((it) => (it.designs || []).map((d) => ({ ...d, produit: it.productTitle })));

    const body = {
      action: 'devis',
      ...devisValues,
      produit: produitResume,
      // URL du premier produit du devis (sans query string ni hash) — pour
      // que le titre du produit puisse être rendu cliquable une fois la
      // note reçue côté Odoo/CRM. Le détail complet (une URL par produit)
      // reste disponible dans "items" pour un devis à plusieurs produits.
      produit_url: items[0]?.productUrl || (window.location.origin + window.location.pathname),
      // Répartition par taille par produit — vide si aucun produit du
      // devis n'utilise la répartition par taille.
      tailles: items.map((it) => it.tailles).filter(Boolean).join(' | '),
      quantite: String(items.reduce((sum, it) => sum + Number(it.qty || 0), 0)),
      sous_total: lineTotal.toFixed(2),
      frais_montage: setupFee.toFixed(2),
      total_estime: (lineTotal + setupFee).toFixed(2),
      personnalisations: personnalisationsResume,
      // Liste structurée des fichiers uploadés (nom de grille, emplacement, URL,
      // produit) — transmise séparément du texte pour rester exploitable par Make/Resend.
      designs: JSON.stringify(allDesigns),
      // Détail structuré complet des produits du devis (nouveau — à mapper
      // côté Make.com/Odoo si un usage plus fin que "produit" en texte
      // libre est souhaité plus tard).
      items: JSON.stringify(items),
      // Parametres publicitaires captures a l'ouverture de la page — a
      // transmettre a Odoo/Make pour matching CAPI (Meta/Google), sur le
      // meme principe que le formulaire Globo existant.
      // "source" distingue explicitement Meta ("facebook_ads_form") de
      // Google ("google_ads_form") — champ directement comparable a celui
      // deja utilise pour le formulaire Globo cote Odoo. fbclid et gclid
      // restent aussi transmis bruts, au cas ou un matching plus fin
      // (CAPI) soit construit plus tard.
      source: adParams.source,
      fbclid: adParams.fbclid,
      gclid: adParams.gclid,
      utm_source: adParams.utm_source,
      utm_medium: adParams.utm_medium,
    };

    try {
      const res = await fetch('/apps/kotmo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error('Erreur envoi');

      trackDevisEvent('submit');
      saveDevisItems([]);

      if (msgEl) {
        msgEl.className = 'kotmo-modal__feedback kotmo-modal__feedback--success';
        msgEl.textContent = t('successMsg');
      }
      if (btn) btn.textContent = t('sent');

    } catch (err) {
      if (msgEl) {
        msgEl.className = 'kotmo-modal__feedback kotmo-modal__feedback--error';
        msgEl.textContent = t('errorMsg');
      }
      if (btn) {
        btn.disabled = false;
        btn.textContent = t('sendRequest');
      }
    }
  };

  /* ── Volume Table ── */
  const renderVolumeTable = () => {
    const tableEl = document.getElementById('kotmo-volume-table');
    if (!tableEl) return;
    if (!afficherGrille) { tableEl.innerHTML = ''; return; }

    const prodTiers = getProdTiers();
    const quantites = (lignesVolume.length
      ? lignesVolume
      : prodTiers.map(t => t.quantity)
    ).filter(q => q >= QTY_MIN);

    if (!quantites.length) { tableEl.innerHTML = ''; return; }

    const maxProdUnit = prodTiers.length ? Math.max(...prodTiers.map(t => t.unit_price)) : 0;

    const getProdUnit = (qty) => {
      let t = null;
      for (const x of prodTiers) { if (qty >= x.quantity) t = x; }
      return t ? t.unit_price : null;
    };

    const getPersoUnit = (qty) => {
      let perso = 0;
      grilles.forEach(g => {
        if (!state.active[g.id]) return;
        perso += computeGrilleUnitCost(g, qty);
      });
      return perso;
    };

    let html = '<div class="knd-bracket">';

    quantites.forEach(qty => {
      const prodUnit = getProdUnit(qty);
      const persoUnit = getPersoUnit(qty);
      const totalUnit = prodUnit != null ? prodUnit + persoUnit : null;
      const totalPrice = totalUnit != null ? totalUnit * qty : null;
      const maxUnit = maxProdUnit + getPersoUnit(qty);
      const save = (totalUnit && maxUnit && totalUnit < maxUnit)
        ? Math.round((1 - totalUnit / maxUnit) * 100)
        : 0;
      const isActive = qty === currentQty;

      html += `<div class="knd-bracket__row${isActive ? ' knd-bracket__row--selected' : ''}" data-qty="${qty}" role="button" tabindex="0" aria-pressed="${isActive}">`;
      html += `<span class="knd-bracket__qty">${qty} ${t('units')}</span>`;
      html += `<span class="knd-bracket__unit">${totalUnit != null ? fmt(totalUnit) + t('perPiece') : '—'}</span>`;
      html += save > 0 ? `<span class="knd-bracket__save">-${save}%</span>` : `<span></span>`;
      html += `<span class="knd-bracket__total">${totalPrice != null ? fmt(totalPrice) : '—'}</span>`;
      html += '</div>';
    });

    const stepHint = QTY_STEP > 1 ? t('stepHint', QTY_STEP) : '';
    const maxHint = QTY_MAX > 0 ? t('maxHint', QTY_MAX) : '';
    const placeholder = `${t('minHint', QTY_MIN)}${stepHint}${maxHint}`;
    const customProdUnit = getProdUnit(currentQty) || 0;
    const customPersoUnit = getPersoUnit(currentQty);
    const customTotalUnit = customProdUnit + customPersoUnit;

    html += `<div class="knd-bracket__row knd-bracket__row--custom">`;
    html += `<span class="knd-bracket__qty knd-bracket__qty--input">
      <input type="number" id="kotmo-custom-qty" value="${currentQty}"
        min="${QTY_MIN}" ${QTY_MAX > 0 ? `max="${QTY_MAX}"` : ''} step="${QTY_STEP}"
        placeholder="${placeholder}" class="kotmo-qty-input">
      <span class="kotmo-qty-hint" id="kotmo-qty-hint"></span>
    </span>`;
    html += `<span class="knd-bracket__unit" id="kotmo-custom-unit">${fmt(customTotalUnit)}${t('perPiece')}</span>`;
    html += `<span></span>`;
    html += `<span class="knd-bracket__total" id="kotmo-custom-total">${fmt(customTotalUnit * currentQty)}</span>`;
    html += '</div></div>';

    tableEl.innerHTML = html;

    tableEl.querySelectorAll('[data-qty]').forEach(row => {
      row.addEventListener('click', () => setQty(Number(row.dataset.qty)));
    });

    const customInput = document.getElementById('kotmo-custom-qty');
    const hintEl = document.getElementById('kotmo-qty-hint');

    if (customInput) {
      const updatePreview = (raw) => {
        const v = parseInt(raw, 10);
        const unitEl = document.getElementById('kotmo-custom-unit');
        const totalEl = document.getElementById('kotmo-custom-total');
        if (isNaN(v)) {
          if (unitEl) unitEl.textContent = '—';
          if (totalEl) totalEl.textContent = '—';
          if (hintEl) hintEl.textContent = '';
          return;
        }
        const corrected = clampQty(v);
        const pu = getProdUnit(corrected) || 0;
        const pe = getPersoUnit(corrected);
        const tu = pu + pe;
        const tp = tu * corrected;
        if (unitEl) unitEl.textContent = fmt(tu) + t('perPiece');
        if (totalEl) totalEl.textContent = fmt(tp);
        customInput.style.borderColor = '';
        if (hintEl) hintEl.textContent = corrected !== v ? t('adjustedTo', corrected) : '';
      };

      customInput.addEventListener('input', () => updatePreview(customInput.value));
      customInput.addEventListener('change', () => {
        const clamped = clampQty(customInput.value);
        customInput.value = clamped;
        customInput.style.borderColor = '';
        if (hintEl) hintEl.textContent = '';
        setQty(clamped);
      });
      customInput.addEventListener('blur', () => {
        const clamped = clampQty(customInput.value);
        if (parseInt(customInput.value, 10) !== clamped) {
          customInput.value = clamped;
          customInput.style.borderColor = '';
          if (hintEl) hintEl.textContent = '';
          setQty(clamped);
        }
      });
      customInput.addEventListener('click', (e) => e.stopPropagation());
      customInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          const c = clampQty(customInput.value);
          customInput.value = c;
          setQty(c);
        }
      });
    }
  };

  const handleUpload = (grilleId, position, file) => {
    if (file.size > MAX_UPLOAD_SIZE) {
      alert(t('fileTooLarge'));
      return;
    }

    const key = `${grilleId}::${position}`;
    state.files[key] = file;
    render();
    uploadFile(grilleId, position, file);
  };

  const render = () => {
    const section = document.getElementById('kotmo-perso-section');
    if (!section) return;

    let html = '<div class="kotmo-perso">';
    html += `<div class="kotmo-perso__title">${t('personalizationTitle')}</div>`;
    html += '<div class="kotmo-perso__cards">';

    // Ordre d'affichage : les personnalisations d'un meme groupe d'exclusivite
    // sont rapprochees visuellement (regroupees ensemble), meme si l'ordre de
    // configuration ne les avait pas placees cote a cote. Les personnalisations
    // hors groupe gardent leur position d'origine.
    const renderOrder = [];
    const groupsAlreadyPlaced = new Set();
    grilles.forEach(g => {
      const grp = getGroupeExclusif(g);
      if (!grp) { renderOrder.push(g); return; }
      if (groupsAlreadyPlaced.has(grp)) return;
      groupsAlreadyPlaced.add(grp);
      grilles.forEach(g2 => { if (getGroupeExclusif(g2) === grp) renderOrder.push(g2); });
    });

    renderOrder.forEach((g, idx) => {
      const isActive = state.active[g.id];
      const isExpanded = state.expanded[g.id];
      const positions = positionsByGrille[g.odooValue] || positionsByGrille[g.nom] || [];
      const posCount = state.positions[g.id].size || 1;
      const perPosition = hasPerPositionSubOptions(g);
      const grp = getGroupeExclusif(g);
      const prevGrp = idx > 0 ? getGroupeExclusif(renderOrder[idx - 1]) : null;
      const nextGrp = idx < renderOrder.length - 1 ? getGroupeExclusif(renderOrder[idx + 1]) : null;

      // Ouverture d'un encadre de groupe : uniquement au premier element du
      // groupe (celui-ci differe du precedent). Un libelle generique indique
      // le comportement "un seul choix" sans exposer le nom interne du groupe.
      if (grp && grp !== prevGrp) {
        html += '<div class="kotmo-perso__group-wrap">';
        html += `<div class="kotmo-perso__group-label">${t('groupHint')}</div>`;
      }

      let priceLabel = '';
      if (isActive) {
        if (g.prixInclus || g.prixDejaInclus) {
          priceLabel = `<span class="kotmo-perso__inclus-badge">${t('inclusInPrice')}</span>`;
        } else {
          const effectiveUnit = computeGrilleUnitCost(g, currentQty);
          if (effectiveUnit > 0) {
            priceLabel = `<span class="kotmo-perso__price">+ ${fmt(effectiveUnit)} /u</span>`;
            if (g.multiplierParEmplacement && posCount > 1) {
              priceLabel += `<span class="kotmo-perso__mult"> × ${posCount}</span>`;
            }
          }
        }
      } else {
        priceLabel = '<span class="kotmo-perso__price--inactive">+ —</span>';
      }

      html += `<div class="kotmo-perso__card${isActive ? ' kotmo-perso__card--active' : ''}">`;
      html += `<div class="kotmo-perso__header" data-expand-grille="${g.id}">`;
      html += `<span class="kotmo-perso__check${isActive ? ' kotmo-perso__check--active' : ''}${grp ? ' kotmo-perso__check--radio' : ''}" data-toggle-grille="${g.id}"></span>`;
      html += `<span class="kotmo-perso__name">${escapeHtml(grilleLabel(g))}</span>`;
      if (g.multiplierParEmplacement) {
        html += `<span class="kotmo-perso__mult-badge">${t('multBadge')}</span>`;
      }
      html += `<span class="kotmo-perso__price-wrap">${priceLabel}</span>`;
      html += `<span class="kotmo-perso__chevron${isExpanded ? ' kotmo-perso__chevron--open' : ''}">▾</span>`;
      html += '</div>';

      if (isExpanded) {
        html += '<div class="kotmo-perso__body">';

        // Sélecteur global de sous-option — uniquement quand un seul
        // emplacement est possible (ou aucun). Sinon, le choix se fait
        // par emplacement, plus bas (dropdown à côté de chaque ligne).
        if (g.sousOptions && g.sousOptions.length && !perPosition) {
          html += '<div class="kotmo-perso__subopts">';
          g.sousOptions.forEach(so => {
            const sel = state.subOption[g.id] === so.name;
            html += `<button class="kotmo-perso__subopt${sel ? ' kotmo-perso__subopt--active' : ''}" data-grille="${g.id}" data-subopt="${so.name}">${escapeHtml(subOptionLabel(g, so.name))}</button>`;
          });
          html += '</div>';
        }

        if (positions.length) {
          html += `<div class="kotmo-perso__positions-label">${t('designLocations')}`;
          if (g.multiplierParEmplacement) {
            html += ` <span class="kotmo-perso__positions-note">${t('designLocationsNote')}</span>`;
          }
          html += '</div>';
          html += `<p class="kotmo-perso__upload-note">${t('uploadNote')}</p>`;
          html += '<div class="kotmo-perso__positions">';

          // N'affiche que les emplacements deja ajoutes par le client — les
          // autres restent disponibles via le menu deroulant "Ajouter un
          // placement" plus bas, plutot que d'afficher toutes les options
          // possibles d'entree de jeu (souvent 6-7 lignes vides).
          const addedPositions = positions.filter(pos => state.positions[g.id].has(pos));
          const availablePositions = positions.filter(pos => !state.positions[g.id].has(pos));

          addedPositions.forEach(pos => {
            // Toujours vrai ici : on n'itere plus que sur les emplacements
            // deja ajoutes. Conserve pour ne pas toucher au reste du corps
            // de ligne (reuseTargets, etc.) qui s'appuie dessus.
            const isSel = true;
            const fileKey = `${g.id}::${pos}`;
            const fileName = state.files[fileKey] ? state.files[fileKey].name : null;
            const hasUrl = !!state.fileUrls[fileKey];
            const isProcessing = !!state.fileProcessing[fileKey];
            const uploadErr = state.fileErrors[fileKey];
            const safePos = pos.replace(/[^a-z0-9]/gi, '-');
            const safeGrille = String(g.id).replace(/[^a-z0-9]/gi, '-');

            let icon = '↑';
            let label = fileName || t('addDesign');
            if (uploadErr) {
              icon = '⚠️';
            } else if (hasUrl) {
              icon = '✓';
            } else if (isProcessing) {
              icon = '⏳';
              label = `${fileName} (${t('uploadProcessing')})`;
            }

            // "Même design que" — emplacements éligibles comme référence :
            // cochés, différents de celui-ci, et eux-mêmes indépendants
            // (pas déjà en train de réutiliser un autre design, pour éviter
            // toute référence circulaire). La ligne elle-même ne s'affiche
            // que si CET emplacement est coché — pas de sens à la proposer
            // pour un emplacement pas encore sélectionné dans la commande.
            const reuseTargets = (perPosition && isSel)
              ? positions.filter(other =>
                  other !== pos &&
                  state.positions[g.id].has(other) &&
                  !(state.sameAsPos[g.id] && state.sameAsPos[g.id][other])
                )
              : [];
            const reuseValue = getReuseTarget(g, pos) || '';
            const isReusing = !!reuseValue;

            html += `<div class="kotmo-perso__pos-row${perPosition ? ' kotmo-perso__pos-row--nested' : ''}">`;
            html += `<span class="kotmo-perso__pos-label">${escapeHtml(positionLabel(pos))}</span>`;

            // Choix imbriqué par emplacement (ex: nombre de couleurs) —
            // menu déroulant compact, affiché pour chaque emplacement
            // dès que la grille en propose plus d'un. Désactivé et grisé
            // si l'emplacement réutilise le design d'un autre (le choix
            // suit alors automatiquement celui de l'emplacement référencé).
            if (perPosition) {
              // Choix EFFECTIF affiché — si l'emplacement réutilise un
              // design ("même design que X"), on montre le nombre de
              // couleurs de X (getEffectiveSubOptionName), pas la valeur
              // propre de cet emplacement qui devient obsolète/non pertinente.
              const currentSub = getEffectiveSubOptionName(g, pos);
              html += `<select class="kotmo-perso__pos-subopt" data-grille="${g.id}" data-pos="${pos}" aria-label="${escapeHtml(t('designLocations'))} — ${escapeHtml(positionLabel(pos))}"${isReusing ? ' disabled' : ''}>`;
              g.sousOptions.forEach(so => {
                const selAttr = so.name === currentSub ? ' selected' : '';
                html += `<option value="${escapeHtml(so.name)}"${selAttr}>${escapeHtml(subOptionLabel(g, so.name))}</option>`;
              });
              html += `</select>`;
            }

            html += `<label class="kotmo-perso__upload${perPosition ? ' kotmo-perso__upload--compact' : ''}${hasUrl ? ' kotmo-perso__upload--done' : ''}${uploadErr ? ' kotmo-perso__upload--error' : ''}${isReusing ? ' kotmo-perso__upload--disabled' : ''}" for="kotmo-file-${safeGrille}-${safePos}">
              <input type="file" id="kotmo-file-${safeGrille}-${safePos}" accept="image/*,.pdf,.ai,.eps" data-grille="${g.id}" data-pos="${pos}" style="display:none"${isReusing ? ' disabled' : ''}>
              <span class="kotmo-perso__upload-icon">${icon}</span>
              <span id="kotmo-upload-label-${safeGrille}-${safePos}" class="kotmo-perso__upload-label">${escapeHtml(label)}</span>
            </label>`;
            if (uploadErr) {
              html += `<span class="kotmo-perso__upload-error-msg">${escapeHtml(uploadErr)}</span>`;
            }
            html += `<button type="button" class="kotmo-perso__pos-remove" data-grille="${g.id}" data-pos="${pos}" aria-label="${escapeHtml(t('removePosition'))}">🗑</button>`;
            html += '</div>';

            // Ligne secondaire "même design que" — uniquement si au moins
            // un autre emplacement coché et indépendant existe pour s'y
            // référer (rien à proposer sinon).
            if (reuseTargets.length > 0) {
              html += `<div class="kotmo-perso__pos-reuse-row">`;
              html += `<span class="kotmo-perso__pos-reuse-label">${escapeHtml(t('reuseLabel'))}</span>`;
              html += `<select class="kotmo-perso__pos-reuse" data-grille="${g.id}" data-pos="${pos}">`;
              html += `<option value=""${!isReusing ? ' selected' : ''}>${escapeHtml(t('reuseNone'))}</option>`;
              reuseTargets.forEach(other => {
                const selAttr = reuseValue === other ? ' selected' : '';
                html += `<option value="${escapeHtml(other)}"${selAttr}>${escapeHtml(t('reuseSameAs', positionLabel(other)))}</option>`;
              });
              html += `</select>`;
              html += `</div>`;
              if (isReusing) {
                html += `<p class="kotmo-perso__reuse-note">${t('reuseNote')}</p>`;
              }
            }
          });

          // Menu deroulant pour ajouter un nouvel emplacement — n'affiche que
          // ceux pas encore ajoutes. Choisir une option l'ajoute directement
          // (le select revient au placeholder au prochain rendu, puisque la
          // ligne correspondante s'affiche desormais a la place).
          if (availablePositions.length > 0) {
            html += `<select class="kotmo-perso__add-position" data-grille="${g.id}">`;
            html += `<option value="" selected>+ ${escapeHtml(t('addPosition'))}</option>`;
            availablePositions.forEach(pos => {
              html += `<option value="${escapeHtml(pos)}">${escapeHtml(positionLabel(pos))}</option>`;
            });
            html += `</select>`;
          }

          html += '</div>';
        }

        html += '</div>';
      }

      html += '</div>';

      if (grp && grp !== nextGrp) {
        html += '</div>';
      }
    });

    html += '</div>';
    html += '<div id="kotmo-volume-table"></div>';

    html += '<div class="kotmo-perso__sticky-bar">';
    html += '<div id="kotmo-setup-fee-line"></div>';

    const totalUnitPrice = computeTotalUnitPrice();
    const lineTotal = totalUnitPrice * currentQty;
    html += `<div class="kotmo-perso__actions">
      <button class="kotmo-perso__btn-devis" id="kotmo-btn-devis" type="button">
        ${t('devisButton')}
      </button>
      <button class="kotmo-perso__btn-atc" id="kotmo-btn-atc" type="button"${externalQtyBlocked ? ' disabled' : ''}>
        ${t('addToCart', fmt(lineTotal))}
      </button>
    </div>`;
    if (storefrontMessage1 || storefrontMessage2) {
      html += '<div class="kotmo-perso__storefront-messages">';
      if (storefrontMessage1) html += `<p class="kotmo-perso__storefront-message">${escapeHtml(storefrontMessage1)}</p>`;
      if (storefrontMessage2) html += `<p class="kotmo-perso__storefront-message">${escapeHtml(storefrontMessage2)}</p>`;
      html += '</div>';
    }
    if (externalQtyBlocked) {
      html += `<p class="kotmo-perso__qty-blocked-note">${t('qtyBelowMinimum', externalQtyMinRequired)}</p>`;
    }
    html += '</div>';

    html += '</div>';

    section.innerHTML = html;
    bindEvents();
    renderVolumeTable();
    renderSetupFeeLine();
  };

  const bindEvents = () => {
    document.querySelectorAll('[data-expand-grille]').forEach(el => {
      el.addEventListener('click', (e) => {
        if (e.target.closest('[data-toggle-grille]')) return;
        const id = Number(el.dataset.expandGrille);
        const wasExpanded = state.expanded[id];
        grilles.forEach(g => { state.expanded[g.id] = false; });
        state.expanded[id] = !wasExpanded;
        render();
      });
    });

    document.querySelectorAll('[data-toggle-grille]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = Number(el.dataset.toggleGrille);
        const g = grilles.find(gr => gr.id === id);
        const isLockedActive = g && g.verrouille && state.active[id];

        if (isLockedActive) {
          // Verrouillee et deja active : le clic ne la desactive jamais,
          // mais permet quand meme d'ouvrir/fermer le detail de ses
          // options (positions, sous-options, etc.).
          const wasExpanded = state.expanded[id];
          grilles.forEach(gr => { state.expanded[gr.id] = false; });
          state.expanded[id] = !wasExpanded;
          render();
          return;
        }

        if (selectionUnique) { grilles.forEach(gr => { if (!gr.verrouille) state.active[gr.id] = false; }); }
        state.active[id] = !state.active[id];
        if (state.active[id]) {
          applyGroupExclusivity(id);
          grilles.forEach(g => { state.expanded[g.id] = false; });
          state.expanded[id] = true;
        }
        render();
        dispatchChange();
      });
    });

    document.querySelectorAll('[data-subopt]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        const grilleId = Number(el.dataset.grille);
        state.subOption[grilleId] = el.dataset.subopt;
        render();
        dispatchChange();
      });
    });

    // Choix imbriqué par emplacement (dropdown couleurs, etc.)
    document.querySelectorAll('.kotmo-perso__pos-subopt').forEach(el => {
      el.addEventListener('click', (e) => e.stopPropagation());
      el.addEventListener('change', (e) => {
        e.stopPropagation();
        const grilleId = Number(el.dataset.grille);
        const pos = el.dataset.pos;
        if (!state.subOptionByPos[grilleId]) state.subOptionByPos[grilleId] = {};
        state.subOptionByPos[grilleId][pos] = el.value;
        render();
        dispatchChange();
      });
    });

    // Ajout d'un emplacement via le menu deroulant "+ Ajouter un placement" —
    // remplace l'ancien bouton toggle : on ne peut plus qu'ajouter depuis ce
    // controle (le retrait se fait via le bouton poubelle de chaque ligne).
    document.querySelectorAll('.kotmo-perso__add-position').forEach(el => {
      el.addEventListener('click', (e) => e.stopPropagation());
      el.addEventListener('change', (e) => {
        e.stopPropagation();
        const grilleId = Number(el.dataset.grille);
        const pos = el.value;
        if (!pos) return;
        state.positions[grilleId].add(pos);
        state.active[grilleId] = true;
        applyGroupExclusivity(grilleId);
        render();
        dispatchChange();
      });
    });

    // Retrait d'un emplacement deja ajoute, via le bouton poubelle en fin de
    // ligne.
    document.querySelectorAll('.kotmo-perso__pos-remove').forEach(el => {
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        const grilleId = Number(el.dataset.grille);
        const pos = el.dataset.pos;
        state.positions[grilleId].delete(pos);
        if (state.positions[grilleId].size === 0) state.active[grilleId] = false;
        // Nettoyage : toute position qui réutilisait le design de celle
        // qu'on vient de retirer doit revenir à un choix indépendant, et si
        // cette position elle-même réutilisait un autre design, on efface
        // aussi cette référence devenue inutile.
        if (state.sameAsPos[grilleId]) {
          Object.keys(state.sameAsPos[grilleId]).forEach(otherPos => {
            if (state.sameAsPos[grilleId][otherPos] === pos) {
              state.sameAsPos[grilleId][otherPos] = null;
            }
          });
          delete state.sameAsPos[grilleId][pos];
        }
        render();
        dispatchChange();
      });
    });

    // "Même design que" — réutilise le choix de couleurs d'un autre
    // emplacement pour économiser le frais de montage.
    document.querySelectorAll('.kotmo-perso__pos-reuse').forEach(el => {
      el.addEventListener('click', (e) => e.stopPropagation());
      el.addEventListener('change', (e) => {
        e.stopPropagation();
        const grilleId = Number(el.dataset.grille);
        const pos = el.dataset.pos;
        if (!state.sameAsPos[grilleId]) state.sameAsPos[grilleId] = {};
        state.sameAsPos[grilleId][pos] = el.value || null;
        render();
        dispatchChange();
      });
    });

    document.querySelectorAll('input[type="file"][data-grille]').forEach(input => {
      input.addEventListener('change', () => {
        if (input.files[0]) handleUpload(Number(input.dataset.grille), input.dataset.pos, input.files[0]);
      });
    });

    document.getElementById('kotmo-btn-atc')?.addEventListener('click', handleAtc);
    document.getElementById('kotmo-btn-devis')?.addEventListener('click', openDevisModal);
  };

  document.addEventListener('kotmo:price-update', (e) => {
    if (!e.detail) return;
    if (typeof e.detail.belowMinimum === 'boolean') {
      externalQtyBlocked = e.detail.belowMinimum;
      externalQtyMinRequired = e.detail.minimumRequired ?? externalQtyMinRequired;
    }
    if (e.detail.sizeBreakdown && typeof e.detail.sizeBreakdown === 'object') {
      externalSizeBreakdown = e.detail.sizeBreakdown;
    }
    if (e.detail.quantity != null) {
      // Sous le minimum externe (ex. grille de tailles pas encore
      // completee), on affiche la vraie quantite saisie plutot que de la
      // remonter artificiellement au minimum du widget (clampQty) — sinon
      // le tableau de paliers et le total affichent un chiffre incorrect
      // pendant que le message d'erreur, lui, parle de la vraie valeur.
      currentQty = externalQtyBlocked
        ? Math.max(0, Number(e.detail.quantity) || 0)
        : clampQty(e.detail.quantity);
    }
    render();
    dispatchChange();
  });

  // Le prix de base peut désormais dépendre de la variante sélectionnée
  // (voir getProdTiers ci-dessus) — on rafraîchit donc l'affichage quand
  // elle change. NOTE : observer directement [data-selected-variant] ne
  // fonctionne PAS — cet élément est remplacé en entier (pas juste son
  // contenu) à chaque changement de variante par le fetch de section du
  // thème, ce qui rend tout observer attaché à l'ancien noeud orphelin
  // aussitôt. <product-info> (l'élément personnalisé englobant tout le
  // bloc produit) lui ne se fait jamais remplacer — seul son contenu
  // interne l'est — donc on l'observe lui, avec subtree, pour capter le
  // remplacement du noeud [data-selected-variant] à l'intérieur.
  const productInfoEl = document.querySelector('product-info');
  if (productInfoEl) {
    // Ne reagit que si l'ID de variante a reellement change — evite une
    // boucle si le widget est lui-meme imbrique dans <product-info> (ses
    // propres re-rendus declencheraient sinon cet observer indefiniment).
    let lastObservedVariantId = getCurrentVariantId();
    new MutationObserver(() => {
      const nowVariantId = getCurrentVariantId();
      if (nowVariantId !== lastObservedVariantId) {
        lastObservedVariantId = nowVariantId;
        dispatchChange();
      }
    }).observe(productInfoEl, { characterData: true, childList: true, subtree: true });
  }

  const injectPropsIntoForms = () => {
    const props = {};
    grilles.forEach(g => {
      if (!state.active[g.id]) return;
      const gLabel = grilleLabel(g);
      const positions = [...state.positions[g.id]];
      const perPosition = hasPerPositionSubOptions(g);

      if (!perPosition && state.subOption[g.id]) {
        props[`Personnalisation - ${gLabel} - Option`] = subOptionLabel(g, state.subOption[g.id]);
      }
      if (positions.length) {
        if (perPosition) {
          props[`Personnalisation - ${gLabel} - Emplacements`] = positions.map(pos => formatPositionDetail(g, pos)).join(', ');
        } else {
          props[`Personnalisation - ${gLabel} - Emplacements`] = positions.map(positionLabel).join(', ');
        }
      }
    });
    document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
      form.querySelectorAll('[data-kotmo-perso-prop]').forEach(el => el.remove());
      Object.entries(props).forEach(([k, v]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${k}]`;
        input.value = v;
        input.dataset.kotmoPerso_prop = '1';
        form.appendChild(input);
      });
    });
  };

  const init = async () => {
    await fetchTranslations();
    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();